module.exports = __webpack_public_path__ + "img/certificateSelected.a0035ed9.jpg";